<template>
<div>
    <b-modal id="matterCustomsRegistrationFormModal" ref="matterCustomsRegistrationFormModal" centered size="xl" no-close-on-backdrop :title= "$t('matter.matter_customs_registration')"  hide-footer>
      <b-card>
             <b-row>
                <b-col>
                    <div class="custom-search d-flex justify-content-end">
                        <b-button variant="outline-primary" size="sm"  @click.prevent="addOrUpdate">
                            {{ $t('others.ok_title') }}
                        </b-button>
                    </div>
                </b-col>
            </b-row>   
            <b-row>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterCustomsRegistration.subject') }}</label>
                         <b-form-group>
                            <b-form-select size="sm" v-model="lawMatterSubjectSelect" value-field="id" text-field="name" :options="lawMatterSubjectOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterCustomsRegistration.registration_number') }}</label>
                        <b-form-group>
                            <b-form-input size="sm"  v-model="registrationNumber" maxlength="100" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterCustomsRegistration.name') }}</label>
                        <b-form-group>
                              <b-form-input size="sm"  v-model="name" disabled />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterCustomsRegistration.renewal_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker disabled today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="renewalDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-3">
                     <b-form>
                        <label>{{ $t('matterCustomsRegistration.application_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="applicationDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterCustomsRegistration.application_no') }}</label>
                        <b-form-group>
                            <b-form-input size="sm"  v-model="applicationNo" maxlength="50" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterCustomsRegistration.response_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="responseDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="matter-customs-registration-conclusion-input">{{ $t('matterCustomsRegistration.conclusion') }}</label>
                        <b-form-group>
                            <b-form-select  size="sm" v-model="conclusionSelect" value-field="id" text-field="name" :options="matterCustomsRegistrationConclusionOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>   
                <b-col class="col-lg-3">
                    <b-form>
                        <label>{{ $t('matterCustomsRegistration.nextRenewalDate') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="nextRenewalDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                        <b-form>
                            <label>{{ $t('matter.process_result') }}</label>
                            <b-form-select size="sm" v-model="lawMatterProcessResultSelect" value-field="id" text-field="name" :options="lawMatterProcessResultOption" />
                        </b-form>
                </b-col>
            </b-row>
            <b-row>
               <b-col class="col-lg-12">
                        <b-form>
                             <label>{{ $t('matterCustomsRegistration.note') }}</label>
                           <b-form-group>
                                <b-form-textarea :placeholder=" $t('matterCustomsRegistration.note')" v-model="note" />
                           </b-form-group>
                        </b-form>
                </b-col>
            </b-row>
           </b-card>
           <b-card :hidden="id == 0">
          <b-row>
            <b-col class="mt-2">
              <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                <b-tab :title="$t('Law MatterCustoms Registration Renewal')" style="width: 100%">
                  <b-card-text>
                    <matter-customs-registration-renewal-list ref="lawMatterCustomsRegistrationRenewalList" :lawMatterCustomsRegistrationId="id"></matter-customs-registration-renewal-list>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
       
      </b-card>
           </b-modal>
</div>
</template>

<script>

export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {

            id: 0,
            lawMatterId: 0,
            lawMatterSubjectOptions:[],
            lawMatterSubjectSelect: 0,
            registrationNumber: '',
            name: '',
            renewalDate: null,
            applicationDate :null,
            applicationNo: '',
            responseDate: null,
            conclusionSelect: 0,
            matterCustomsRegistrationConclusionOption: [],
            lawMatterProcessResultOption: [],
            lawMatterProcessResultSelect: 0,
            nextRenewalDate: null,
            previousRenewalDate: null,
            note: '',
            empId: 0
        }
    },
    methods: {
        async showCustomsRegistration(id, lawMatterId,employeeId) {
            this.$refs['matterCustomsRegistrationFormModal'].show()
            this.empId = employeeId
            this.id = id
            this.lawMatterId = lawMatterId
            const data = { id: this.id }
               
            const controller = { name: 'LawMatterCustomsRegistration' }
            const payload = { data: data, controller: controller}
               
            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus) {
                    this.matterCustomsRegistrationConclusionOption = response.data.lawMatterConclusionList
                    this.matterCustomsRegistrationConclusionOption.splice(0, 0, this.$nullSelected())
                    this.conclusionSelect = response.data.lawMatterCustomsRegistration.lawMatterConclusionId

                    this.lawMatterSubjectOptions = response.data.lawMatterSubjectList
                    this.lawMatterSubjectOptions.splice(0, 0, this.$nullSelected())
                    this.lawMatterSubjectSelect = response.data.lawMatterCustomsRegistration.lawMatterSubjectId

                    this.registrationNumber = response.data.lawMatterCustomsRegistration.registrationNumber
                    this.responseDate = response.data.lawMatterCustomsRegistration.responseDate
                    this.nextRenewalDate = response.data.lawMatterCustomsRegistration.nextRenewalDate
                    this.previousRenewalDate = this.nextRenewalDate
                    this.applicationNo = response.data.lawMatterCustomsRegistration.applicationNo
                    this.applicationDate = response.data.lawMatterCustomsRegistration.applicationDate
                    this.note = response.data.lawMatterCustomsRegistration.note
                    this.name = response.data.lawMatterCustomsRegistration.name
                    this.renewalDate = response.data.lawMatterCustomsRegistration.renewalDate

                     this.lawMatterProcessResultOption = response.data.lawMatterProcessResultList
                     this.lawMatterProcessResultOption.splice(0, 0, this.$nullSelected())
                     this.lawMatterProcessResultSelect = response.data.lawMatterCustomsRegistration.lawMatterProcessResultId
                       
                } else {
                    this.$bvModal.hide('matterCustomsRegistrationFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
        },
        async addOrUpdate() {
            const  lawMatterCustomsRegistrationData = {
                            id: this.id,
                            lawMatterId: this.lawMatterId,
                            lawMatterConclusionId: this.conclusionSelect,
                            registrationNumber: this.registrationNumber,
                            responseDate: this.responseDate,
                            nextRenewalDate: this.nextRenewalDate,
                            applicationDate: this.applicationDate,
                            applicationNo: this.applicationNo,
                            lawMatterSubjectId: this.lawMatterSubjectSelect,
                            lawMatterProcessResultId :this.lawMatterProcessResultSelect,
                            note: this.note

                        }
            const controller = {
                name: 'LawMatterCustomsRegistration'
            }
            const payload = {
                data: lawMatterCustomsRegistrationData,
                controller: controller
            }
            const response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus) {
                if(!this.id){
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(3, this.id, this.lawMatterId,this.employeeId) 
                    this.getMatterTypeHistoryList()
                }
                if(this.nextRenewalDate && this.previousRenewalDate!= this.nextRenewalDate){
                    const lawReminderResponse = await this.upsertLawReminder({
                        lawMatterId: this.lawMatterId,
                        nextRenewalDate: this.nextRenewalDate,
                        previousRenewalDate: this.previousRenewalDate,
                        employeeId: this.empId,
                        note: this.$t('matterCustomsRegistration.reminder_note'),

                    });
                    if (!lawReminderResponse.data.resultStatus) {
                         this.$WarningAlert(lawReminderResponse.data.resultMessage);
                        }
                }
                //this.$bvModal.hide('matterCustomsRegistrationFormModal')
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        },
        async upsertLawReminder(data){
           const  controller = { name: 'LawReminder',actionName:'UpsertLawReminderByLawMatter'}
           const payload = { data: data, controller: controller}
           const response = await this.$store.dispatch('moduleAuth/customService', payload)
           return response;
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
